import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — attach JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — handle 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      // Skip redirect for the login endpoint itself — let LoginPage show the inline error
      const isLoginRequest = originalRequest?.url?.includes('/auth/login');
      if (isLoginRequest) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        try {
          const { data } = await axios.post(
            `${import.meta.env.VITE_API_URL || '/api'}/auth/refresh`,
            { refreshToken }
          );
          const newToken = data.token ?? data.accessToken;
          localStorage.setItem('token', newToken);
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        } catch {
          // Refresh failed — clear storage and redirect
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          window.location.href = import.meta.env.BASE_URL + 'login';
          return Promise.reject(error);
        }
      } else {
        localStorage.removeItem('token');
        window.location.href = import.meta.env.BASE_URL + 'login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
